const packageService = {
  modalDuplicatePackage: {
    title: 'Duplicate Package',
    packageSelected: 'Package Selected',
    package: 'Package',
    packageName: 'Package Name'
  }
}

export default packageService
